<template>
  <div class="mediapipe-container">
    <video ref="input_video" width="100%" height="100%" style="display: none;"></video>
    <div style="position:relative;">
      <canvas
          v-show="this.poseListens.length > 0"
          class="output_canvas"
          ref="output_canvas"
          :width="width"
          :height="height"
      ></canvas>
      <canvas
          v-show="this.handsListens.length > 0"
          class="output_canvas"
          ref="take_photo_canvas"
          :width="width"
          :height="height"
      ></canvas>
    </div>
  </div>
</template>

<script>
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { Pose, POSE_CONNECTIONS } from "@mediapipe/pose";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Row, Col, Grid, GridItem, Dialog } from 'vant'
import {
  checkVictory,
  checkOkay,
  CheckLeftStroke,
  CheckRightStroke,
  checkWrongPose,
  checkRightPose
} from '@/utils/mediapipe'
export default {
  name: 'mediapipe',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button
  },
  props: {
    handsListens: {
      type: Array,
      default: function(){
        return ['victory', 'okay']
      }
    },
    poseListens: {
      type: Array,
      default: function(){
        return ['forward', 'back']
      }
    },
    selectListens: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      handsCtx: null,
      width: null,
      height: null,
      handsImage: '',
      photoTaking: false,
      loading: 0,
      leftHandsLine: [],
      rightHandsLine: [],
    };
  },
  computed: {
    inputVideo() {
      return this.$refs.input_video;
    },
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.handsCtx = this.$refs.take_photo_canvas.getContext("2d");
    this.init();
  },
  methods: {
    init() {
      this.handsImage = new Image();
      this.handsImage.src = require('@/assets/hands.png');
      window.requestAnimationFrame(this.pose);
    },
    pose() {
      const pose = new Pose({
        locateFile: (file) => {
          console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/pose@0.5.1635988162/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5.1635988162/${file}`;
        },
      });
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: true,
        smoothSegmentation: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      pose.onResults(this.onResults);


      const hands = new Hands({
        locateFile: (file) => {
          // console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/hands@0.3.1632795355/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/hands@0.3.1632795355/${file}`;
        },
      });
      hands.setOptions({
        maxNumHands: 1,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });
      hands.onResults(this.onHandsResults);

      this.camera = new Camera(this.inputVideo, {
        onFrame: async () => {
          if(this.poseListens.length){
            await pose.send({ image: this.inputVideo })
          }
          if(this.handsListens.length){
            await hands.send({ image: this.inputVideo })
          }
        },
        facingMode: this.$store.getters.facingMode,
      })
      this.camera.start()
    },
    onResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;
      this.ctx.save();
      this.ctx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.ctx.translate(results.image.width, 0);
      this.ctx.scale(-1, 1);
      // console.log(results.image)
      this.ctx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );

      if (results.poseLandmarks) {

        if(this.selectListens > 0 && this.poseListens.indexOf('select') !== -1) {
          if(
              results.poseLandmarks[20]['visibility'] > 0.8 &&
              results.poseWorldLandmarks[20]['y'] < results.poseWorldLandmarks[12]['y']
              && results.poseWorldLandmarks[20]['y'] > results.poseWorldLandmarks[10]['y']
          ){
            const index = Math.floor((1 - results.poseLandmarks[20]['x']) / (1 / this.selectListens))
            this.$emit('select', index)
            // 返回选择题位置
          }
        }

        if(this.poseListens.indexOf('right') !== -1) {
          checkRightPose(results.poseLandmarks).then(res => {
            this.$emit('right')
            // 正确姿势
          }).catch(err => {
            // console.log(err)
          })
        }
        if(this.poseListens.indexOf('wrong') !== -1) {
          checkWrongPose(results.poseLandmarks).then(res => {
            this.$emit('wrong')
            // 错误姿势
          }).catch(err => {
            // console.log(err)
          })
        }

        if(this.poseListens.indexOf('forward') !== -1){
          if(results.poseLandmarks[19]['visibility'] > 0.8){

            this.leftHandsLine.push(results.poseLandmarks[19])
            if(this.leftHandsLine.length > 6){
              this.leftHandsLine.shift()

              CheckLeftStroke(results.poseLandmarks, this.leftHandsLine).then(res => {
                this.leftHandsLine = []
                this.$emit('forward')
                // 前进
                // Toast('识别左手往右划')
              }).catch(err => {
                console.log('forward:' + err)
              })
            }
          }
        }

        if(this.poseListens.indexOf('back') !== -1){
          if(results.poseLandmarks[20]['visibility'] > 0.8){

            this.rightHandsLine.push(results.poseLandmarks[20])
            if(this.rightHandsLine.length > 6){
              this.rightHandsLine.shift()

              CheckRightStroke(results.poseLandmarks, this.rightHandsLine).then(res => {
                this.rightHandsLine = []
                this.$emit('back')
                // 后退
                // Toast('识别右手往左划')
              }).catch(err => {
                console.log('back:' + err)
              })
            }
          }
        }

        drawConnectors(this.ctx, results.poseLandmarks, POSE_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 4,
        });
        drawLandmarks(this.ctx, results.poseLandmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
        // }
      }
      this.ctx.restore();
      this.ctx.font = '80px STheiti, SimHei'
      this.ctx.fillStyle = "green"

      // const dataURL = this.$refs.output_canvas.toDataURL('image/png')

    },
    onHandsResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;

      this.handsCtx.save();
      this.handsCtx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.handsCtx.translate(results.image.width, 0);
      this.handsCtx.scale(-1, 1);
      this.handsCtx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );

      for (const landmarks of results.multiHandLandmarks) {
        drawConnectors(this.handsCtx, landmarks, HAND_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 5,
        });
        drawLandmarks(this.handsCtx, landmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
      }
      // this.findHands(results);
      this.handsCtx.restore();

      if (results.multiHandLandmarks) {
        for (const landmarks of results.multiHandLandmarks) {
          if(this.handsListens.indexOf('victory') !== -1){
            checkVictory(landmarks).then(res => {
              this.$emit('victory')
              // 成功
            }).catch(err => {
              console.log('victory:' + err)
            })
          }
          if(this.handsListens.indexOf('okay') !== -1){
            checkOkay(landmarks).then(res => {
              this.$emit('okay')
            }).catch(err => {
              console.log('okay:' + err)
            })
          }
          break
        }
      }
      this.handsCtx.restore();
      this.handsCtx.save();
    },
    takePhoto(){
      return new Promise((resolve, reject) =>{
        if(this.photoTaking){
          reject('拍照中，不能连续操作')
        }else{
          this.photoTaking = true
          this.$refs.take_photo_canvas.toBlob((blob)=>{
            setTimeout(()=>{
              this.photoTaking = false
            }, 3000)
            resolve(blob)
            // this.$emit('take-photo', blob)
          },'image/png')
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.camera.stop()
    next()
  }
}
</script>

<style scoped>
.mediapipe-container{
  position: absolute;
  width: 50%;
  top: 0;
  opacity: 0.9;
}
.output_canvas {
  width: 100%;
  height: 200%;
}
</style>
